export const linkResolver = (doc: { type?: string; uid?: string } | null | undefined): string => {
  if (!doc) {
    return '/'
  }

  switch (doc.type) {
    case 'homepage':
      return `/`
    case 'products':
      return `/product/${doc.uid}`
    case 'solutions':
      return `/solutions/${doc.uid}`
    case 'case_studies':
      return `/solutions/case-studies/${doc.uid}`
    case 'industries':
      return `/solutions/industries/${doc.uid}`
    case 'resources':
      return `/resources/${doc.uid}`
    case 'blog':
      return `/blog/${doc.uid}`
    case 'page':
      if (doc.uid === 'industries') {
        return '/solutions/industries'
      }
      if (doc.uid === 'case-studies') {
        return '/solutions/case-studies'
      }
      return `/${doc.uid}`
    default:
      return `/`
  }
}
